module.exports = __webpack_public_path__ + "static/media/view-data.65834351.svg";